module.exports = __webpack_public_path__ + "static/assets/de82665d879a40295c5ed0b5b363f906.png";